import appConfig from '../../config';

export default {
    api: {
        url: appConfig.apiServerUri,
        error: null,
        loading: false
    }
};
